import { motion } from "framer-motion";
import { MapPin, Clock, Mail, ExternalLink, Instagram } from "lucide-react";

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Corso+Giuseppe+Mazzini+25A+Novara";

const Contact = () => (
  <section id="contatti" data-testid="contact-section" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-20 lg:py-32">
    <motion.div
      initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
      className="mb-14"
    >
      <p className="text-xs sm:text-sm uppercase tracking-[0.25em] text-[#0B1F3A] font-mono-alt font-medium mb-4">Contatti & Orari</p>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
        <span className="gold-text">Contatti</span>
      </h2>
    </motion.div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
      <motion.div
        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
        className="rounded-2xl border border-[rgba(11,31,58,0.2)] bg-[#FFFFFF] p-6 sm:p-8 hover:border-[rgba(11,31,58,0.5)] transition-colors duration-500"
      >
        <MapPin className="w-6 h-6 text-[#0B1F3A] mb-5" strokeWidth={1.5} />
        <h3 className="font-display text-xl font-semibold mb-3">Dove siamo</h3>
        <p data-testid="contact-address-text" className="text-[#6F6466] text-sm leading-relaxed mb-4">
          Corso Giuseppe Mazzini 25A<br />28100 Novara (NO)
        </p>
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-maps-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#071528] hover:text-[#071528] transition-colors duration-300"
        >
          Apri in Google Maps <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
        className="rounded-2xl border border-[rgba(11,31,58,0.2)] bg-[#FFFFFF] p-6 sm:p-8 hover:border-[rgba(11,31,58,0.5)] transition-colors duration-500"
      >
        <Clock className="w-6 h-6 text-[#0B1F3A] mb-5" strokeWidth={1.5} />
        <h3 className="font-display text-xl font-semibold mb-3">Orari di apertura</h3>
        <div data-testid="contact-hours-text" className="text-sm text-[#6F6466] space-y-2">
          <div className="flex justify-between gap-4"><span>Lunedì – Sabato</span><span className="text-[#1A1416]">09:00 – 12:30</span></div>
          <div className="flex justify-between gap-4"><span className="invisible">-</span><span className="text-[#1A1416]">13:30 – 19:30</span></div>
          <div className="flex justify-between gap-4"><span>Domenica</span><span className="text-[#0B1F3A]">Chiuso</span></div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
        className="rounded-2xl border border-[rgba(11,31,58,0.2)] bg-[#FFFFFF] p-6 sm:p-8 hover:border-[rgba(11,31,58,0.5)] transition-colors duration-500"
      >
        <Mail className="w-6 h-6 text-[#0B1F3A] mb-5" strokeWidth={1.5} />
        <h3 className="font-display text-xl font-semibold mb-3">Scrivici</h3>
        <p className="text-[#6F6466] text-sm leading-relaxed mb-4">Per qualsiasi domanda su servizi e disponibilità.</p>
        <a
          href="mailto:banybarbershop@gmail.com"
          data-testid="contact-email-text"
          className="text-sm text-[#071528] hover:text-[#071528] transition-colors duration-300 break-all"
        >
          banybarbershop@gmail.com
        </a>
        <a
          href="https://instagram.com/bany.barber"
          target="_blank"
          rel="noreferrer"
          data-testid="contact-instagram-link"
          className="mt-4 flex items-center gap-2 text-sm text-[#0B1F3A] hover:text-[#2A4A85] transition-colors duration-300"
        >
          <Instagram className="w-4 h-4" strokeWidth={1.8} /> @bany.barber
        </a>
      </motion.div>
    </div>
  </section>
);

export default Contact;
